export default {
  name: 'vans-prod',
  appId: 'wx4dd38c9972082aa9',
  wechatId: '208'
};